import { Box, InputLabel, TextField, Typography } from "@mui/material";
import MainModal from "components/MainModal";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import React, { useEffect, useState } from "react";
import { IEditFishboneProblemStatementModal } from "../RCAFishboneDiagramInterfaces";
import { useTranslation } from "react-i18next";

const EditFishboneProblemStatementModal = ({
    open,
    onClose,
    problemStatementText,
    onSaveProblemStatement,
    disabled,
}: IEditFishboneProblemStatementModal) => {
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();
    const [currentproblemStatementText, setCurrentproblemStatementText] = useState<string>(problemStatementText!);

    useEffect(() => {
        setCurrentproblemStatementText(problemStatementText!);
    }, [problemStatementText]);

    const handleOnClose = () => {
        setCurrentproblemStatementText("");
        onClose();
    };

    return (
        <MainModal
            isOpen={open}
            onClose={handleOnClose}
            title={t("rca.rca_library.rca_detail.fishbone_diagram.edit_problem_statement_title")}
            showCloseButton
            customModalStyles={{ width: 600 }}
            onOkButtonClick={() => {
                onSaveProblemStatement(currentproblemStatementText || "");
                handleOnClose();
            }}
            okButton={t("rca.rca_library.rca_detail.fishbone_diagram.save")}
            disableOkButton={!currentproblemStatementText?.trim() || disabled}
        >
            <Box className={`${mainClasses.contentFormBox} ${mainClasses.contentCardContent}`}>
                <InputLabel id="outlined-actionPlanDescription-label">
                    <Typography variant="subtitle2" className={mainClasses.contentFormLabelMaxWidth}>
                        {t("rca.rca_library.rca_detail.fishbone_diagram.problem_statement_label")}
                    </Typography>
                </InputLabel>
                <TextField
                    fullWidth
                    className={mainClasses.contentFormMultitextField}
                    multiline
                    rows={3}
                    type="text"
                    placeholder={t("rca.rca_library.rca_detail.fishbone_diagram.problem_statement_placeholder")}
                    variant="outlined"
                    value={currentproblemStatementText}
                    onChange={(e) => setCurrentproblemStatementText(e.target.value)}
                />
            </Box>
        </MainModal>
    );
};

export default EditFishboneProblemStatementModal;
